import { memo } from "react";

import { Switch } from "@headlessui/react";

import { tw } from "classnames";

export type ToggleCommonProps = {
  alt?: string;
  disabled?: boolean;
  onChange?: (value: boolean) => void;
  type?: "default" | "onOff";
};
interface Props extends ToggleCommonProps {
  value: boolean;
}

const switchWrapperStyles = {
  default: tw(
    "relative",
    "inline-flex",
    "h-6",
    "w-12",
    "p-0",
    "items-center",
    "rounded-full",
    "border",
    "border-solid",
    "border-primary"
  ),
  off: tw(
    "bg-white",
    "disabled:bg-interactive-disabled",
    "disabled:border-interactive-disabled-text"
  ),
  on: tw(
    "bg-background-primary-inverse",
    "disabled:bg-interactive-disabled-text",
    "disabled:border-interactive-disabled-text"
  ),
};

const switchStyles = {
  default: tw(
    "absolute",
    "inset-px",
    "w-4.5",
    "rounded-full",
    "transform",
    "transition",
    "border",
    "border-solid",
    "cursor-pointer"
  ),
  off: tw("bg-white"),
  on: tw("bg-white"),
  disabled: tw("border-interactive-disabled-text"),
  toggleOn: tw("translate-x-6"),
  toggleOff: tw("translate-x-0"),
};

const ToggleViewBase = ({
  alt,
  disabled = false,
  onChange,
  type = "default",
  value,
}: Props) => {
  const switchWrapperClasses = tw(
    switchWrapperStyles.default,
    type === "onOff" && !value
      ? switchWrapperStyles.off
      : switchWrapperStyles.on
  );

  const switchClasses = tw(
    switchStyles.default,
    type === "onOff" && !value ? switchStyles.off : switchStyles.on,
    !value ? switchStyles.toggleOff : switchStyles.toggleOn,
    {
      [switchStyles.disabled]: disabled,
    }
  );

  return (
    <Switch
      checked={value}
      className={switchWrapperClasses}
      disabled={disabled}
      onChange={onChange}
    >
      <span className="sr-only">{alt}</span>
      <span className={switchClasses} />
    </Switch>
  );
};

export const ToggleView = memo(ToggleViewBase);
